import scroll from 'scroll';
import hasDom from 'has-dom';
import scrollDoc from 'scroll-doc';
import { defaultOptions } from '../smoothScroll/index.js';

/**
 * smoothScrollByPosition
 *
 * options:
 *  - container (Node): container of scrollable area - default = document
 *  - direction (String): 'top' or 'left'
 *  - duration (Number)
 *  - ease (func)
 *  - callbackAfterScroll (func)
 *
 * @param pos (Number): x or y position
 * @param options (Object)
 */
export default function smoothScrollByPosition(pos, options) {
  if (options === void 0) {
    options = {};
  }
  if (hasDom()) {
    const {
      direction = 'top',
      container,
      callbackAfterScroll = () => {},
      ...rest
    } = options;
    const scrollContainer = container || scrollDoc();
    scroll[direction](scrollContainer, pos, {
      ...defaultOptions,
      ...rest
    }, callbackAfterScroll);
  }
}